/**
 * @generated SignedSource<<f2534c0b1940b69ac7f7ec708ec4c5ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PixDialogGetCharge_charge$data = {
  readonly correlationID: string | null | undefined;
  readonly metaPixel: {
    readonly token: string | null | undefined;
  } | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Order_charge" | "Plugin_charge" | "useMeta_charge">;
  readonly " $fragmentType": "PixDialogGetCharge_charge";
};
export type PixDialogGetCharge_charge$key = {
  readonly " $data"?: PixDialogGetCharge_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PixDialogGetCharge_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationMetaPixel",
  "kind": "LinkedField",
  "name": "metaPixel",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PixDialogGetCharge_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Plugin_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Order_charge"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeta_charge",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "correlationID",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "d0db8cce9e42d18bc969cdc3728807b1";

export default node;
